import {Component, OnInit} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe, NgFor, NgForOf, NgIf} from "@angular/common";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {Router} from "@angular/router";

@Component({
    selector: 'app-tsp-xtos-shpmnt-rpt-status',
    imports: [
        ReactiveFormsModule
    ],
    templateUrl: './tsp-xtos-shpmnt-rpt-status.component.html',
    styleUrl: './tsp-xtos-shpmnt-rpt-status.component.css'
})
export class TspXtosShpmntRptStatusComponent implements OnInit {
  xtosDelinqReport: FormGroup;
  reportingYrList;
  printQtrList;

  constructor(private fb: FormBuilder, private router: Router ) {
  }

  ngOnInit() {
    this.populateXtosReportFormGroup();
  }

  onSingleShipmentReportClicked() {
    this.router.navigate(['/tspXtosSingleShpmntRptStatus']);
  }
  onBatchShipmentReportClicked() {
    this.router.navigate(['/tspXtosBatchShpmntRpt']);
  }

  onComprehensiveShipmentReportClicked() {
    this.router.navigate(['/tspXtosComprehensiveRpt']);
  }

  populateXtosReportFormGroup() {
    this.xtosDelinqReport = this.fb.group({
      reportingYrSelect: new FormControl('', Validators.required),
      reportingQtrSelect: new FormControl('', Validators.required)
    });
  }

  getXtosDelinqReport() {}

  getDelinqEmailStatus() {
  }

}
